import { ApiError } from '@/api'

// The membership-removal endpoint's two documented business rules
// (CustomerUsersService.detachUser: self-detach, last-admin detach) ride a
// {validationMessages:[{errorName}]} body — the same violation shape the
// admin API uses for its other 400s (e.g. duplicate email on registration).
// Only the errorName of the first entry is meaningful here since the
// endpoint only ever raises one violation at a time.
interface ViolationErrorBody {
  validationMessages?: Array<{ errorName?: string }>
}

export type MembershipViolationCode = 'cannotRemoveSelf' | 'lastAdmin' | 'unknown'

// Maps a failed removeUserMembership call to the violation code the screen
// renders copy for. Anything that isn't one of the two known codes —
// including errors that aren't a 400 violation at all — collapses to
// 'unknown' so the caller always has a code to render rather than needing to
// re-check ApiError-ness itself.
export function membershipViolationCode(error: unknown): MembershipViolationCode {
  const body = error instanceof ApiError ? (error.details as ViolationErrorBody | undefined) : undefined
  const errorName = body?.validationMessages?.[0]?.errorName
  return errorName === 'cannotRemoveSelf' || errorName === 'lastAdmin' ? errorName : 'unknown'
}
